import { Accordion, AccordionItem, AccordionPanel, AccordionTrigger } from '@wundo/ui';
import type { ConversationDebugRoleplay } from '@/lib/conversationDebug.ts';
import { DebugRow, DebugSection } from './DebugSection.tsx';

/** The practice this conversation was: its scenario, and how the debrief rated it. */
export function RoleplaySection({ roleplay }: { roleplay: ConversationDebugRoleplay }) {
  return (
    <DebugSection title='Roleplay'>
      <dl>
        <DebugRow label='Status'>{roleplay.status}</DebugRow>
        <DebugRow label='Mode'>{roleplay.mode ?? '—'}</DebugRow>
        <DebugRow label='Situation'>{roleplay.scenario.situation}</DebugRow>
        <DebugRow label='Persona'>
          {roleplay.scenario.persona.name} — {roleplay.scenario.persona.role} (
          {roleplay.scenario.persona.behavior})
        </DebugRow>
        <DebugRow label='Objectives'>
          <ul className='list-disc pl-5'>
            {roleplay.scenario.learning_objectives.map((objective, index) => (
              <li key={index}>{objective}</li>
            ))}
          </ul>
        </DebugRow>
        {roleplay.source_conversation_id && (
          <DebugRow label='Intake conversation'>
            <code className='text-xs'>{roleplay.source_conversation_id}</code>
          </DebugRow>
        )}
      </dl>
      {roleplay.debrief && (
        <Accordion>
          <AccordionItem>
            <AccordionTrigger className='px-3.5 py-2.5 text-sm'>Debrief</AccordionTrigger>
            <AccordionPanel className='flex flex-col gap-2 px-3.5 pb-3 text-ink-body'>
              {roleplay.debrief.took_part === false ? (
                <p>User did not take part; nothing rated</p>
              ) : (
                <DebriefDetails debrief={roleplay.debrief} />
              )}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
    </DebugSection>
  );
}

function DebriefDetails({
  debrief,
}: {
  debrief: NonNullable<ConversationDebugRoleplay['debrief']>;
}) {
  return (
    <>
      <p>
        <span className='font-bold'>Recap:</span> {debrief.recap}
      </p>
      <ul className='list-disc pl-5'>
        {debrief.ratings.map((rating, index) => (
          <li key={index}>
            <span className='font-bold'>{rating.objective}</span> — {rating.score}/5:{' '}
            {rating.feedback}
          </li>
        ))}
      </ul>
      <p>
        <span className='font-bold'>Standout:</span> {debrief.standout}
      </p>
      <p>
        <span className='font-bold'>Tip:</span> {debrief.tip}
      </p>
    </>
  );
}
